import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useSelectedBoat } from '@/entities/boat';
import SearchSvg from '@/shared/assets/icons/ui-kit/search.svg';
import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';
import { useNamespace } from '@/shared/lib/hooks/use-namespace.hook';
import { Autocomplete } from '@/shared/ui/autocomplete';

import { selectBoatInput } from '../../model/selectors/select-boat-input';
import { useUpdateBoatId } from '../../model/utils/hooks/use-update-boat-id.hook';
import { SearchBoatMobile } from './mobile';
import { SearchBoatProps } from './search-boat.types';

// TODO: component is no longer used
const SearchBoatComponent = ({ className }: SearchBoatProps) => {
	const namespace = useNamespace('common');
	const { t } = useTranslation(namespace as ['plant', 'common'] | 'common');
	const { items, length } = useSelector(selectBoatInput);
	const selectedBoat = useSelectedBoat();
	const isMobile = useMatchMedia('mobile');
	const onChangeBoat = useUpdateBoatId({ redirect: true });

	if (length === 0) {
		return null;
	}

	if (isMobile) {
		return <SearchBoatMobile boats={items} onChangeBoat={onChangeBoat} selectedBoat={selectedBoat?.id ?? ''} />;
	}

	return (
		<Autocomplete
			options={items}
			values={[selectedBoat?.id ?? '']}
			onChange={onChangeBoat}
			placeholder={t('header.input.placeholder')}
			Adornment={SearchSvg}
			className={className}
			arrow={false}
			showBeforeSearch={false}
		/>
	);
};

export default memo(SearchBoatComponent);
